import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Paper from 'material-ui/Paper';
import MachineList from '../components/MachineList'
import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import { Link } from 'react-router';
import PageLoading from '../components/PageLoading';
import {dateStr} from '../utils/TimeFormatter';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import Person from 'material-ui/svg-icons/social/person';
import Room from 'material-ui/svg-icons/action/room';
import moment from 'moment-timezone';
import RaisedButton from 'material-ui/RaisedButton';


import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';


export default
@observer class DeletionsPage extends Component {

  formatTime(timestamp) {
    return moment(timestamp)
      .tz(AppModel.time_zone)
      .locale(AppModel.locale).format("LLL");
  }

  restoreItem(delOp) {
    return function() {
      console.log("Should restore:",delOp);
      var restoreAction = null;
      if(delOp.type == 'User')
        restoreAction = AppModelUtils.undeleteUser(delOp.id_user);
      if(delOp.type == 'Location')
        restoreAction = AppModelUtils.undeleteLocations(delOp.timestamp);
      restoreAction.then(()=> {
          console.log("Restore completed");
      })
      .catch(()=> {
          console.log("Restore failed");
      });
    }
  }
  render() {
    // Each delete operation will be presented to the user as a single
    // item, with a restore option.
    // Each item will have a type, timestamp, title, description.

    var deletions = AppModel.deletions;
    var uiDeletionOperations = [];
    if(deletions) {
      deletions.location_deletions.forEach( locationDeletion => {
        var delItem = { type:'Location',
                        icon:<Room />,
                        timestamp:locationDeletion.deleted_ts
                      }
        if(locationDeletion.count > 1) {
          delItem.title = uiMsg('DP_LOCATION_TITLE_PLURAL'," <X> locations",locationDeletion.count);
          var descStr = locationDeletion.room_names.join(", ");
          if(descStr.length>30) descStr=descStr.substring(0,30)+"...";
          descStr = uiMsg('DP_ROOM_NAMES',"Room names : <X>",descStr);
          delItem.description = descStr;
        } else {
          delItem.title = uiMsg('DP_LOCATION',"Location");
          delItem.description = uiMsg('DP_ROOM_NAME',"Room name : <X>",locationDeletion.room_names[0]);
        }
        delItem.title = this.formatTime(delItem.timestamp)+", "+delItem.title;
        uiDeletionOperations.push(delItem);
      });
      deletions.user_deletions.forEach( userDeletion => {
        var delItem = { type:'User',
                        icon:<Person />,
                        timestamp:userDeletion.deleted_ts,
                        id_user:userDeletion.id,
                      };
        delItem.title = uiMsg('DP_ACCOUNT_TITLE',"User account : <account.id>",userDeletion.id);
        delItem.description = userDeletion.name+"/"+userDeletion.email;
        delItem.title = this.formatTime(delItem.timestamp)+", "+delItem.title;
        uiDeletionOperations.push(delItem);
      });
      // Finally we sort the deletions by descending deleted timestamp
      uiDeletionOperations.sort((a,b) => {
        if(a.timestamp > b.timestamp) return -1;
        if(a.timestamp < b.timestamp) return 1;
        return 0;
      });
    }

    return (
        <PageLoading loading={AppModel.fetchingDeletions || AppModel.restoringDeletion}>
          <List><Subheader>{uiMsg('DP_DELETE_OPS_LAST30D',"Delete operations, last 30 days")}</Subheader>

            {uiDeletionOperations.map( delOp =>
              <ListItem
                  key={delOp.timestamp}
                  leftAvatar={delOp.icon }
                  primaryText={delOp.title}
                  secondaryText={delOp.description}
                  secondaryTextLines={1}
                  disabled = {true}
                  rightIcon={<IconMenu iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                                anchorOrigin={{horizontal: 'right', vertical: 'center'}}
                                targetOrigin={{horizontal: 'right', vertical: 'center'}}
                                style={{top:"-8px",right:"16px"}}
                                onItemTouchTap={this.restoreItem(delOp)}
                              >
                              <MenuItem primaryText={uiMsg('DP_RESTORE_MENU_ITEM',"Restore")} />
                            </IconMenu>}

               />
            )}
          </List>
        </PageLoading>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/pages/DeletionsPage.jsx
 **/